/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Filter_All_Categories1Inputs */

const vi_cmspost_filter_all_categories1 = /** @type {(inputs: Cmspost_Filter_All_Categories1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mọi chuyên mục`)
};

/**

* @param {Cmspost_Filter_All_Categories1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_filter_all_categories1 = /** @type {((inputs?: Cmspost_Filter_All_Categories1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Filter_All_Categories1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_filter_all_categories1(inputs)
});
export { cmspost_filter_all_categories1 as "cmsPost_filter_all_categories" }